import React, { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import classNames from 'classnames';

import { ReactComponent as LogoSvg } from './new-logo.svg';
import { ReactComponent as LogoWhiteSvg } from './new-logo-white.svg';
import styles from './logo.module.scss';

type LogoProps = SvgIconProps & {
    title?: string;
    white?: boolean;
};

const Logo: FC<LogoProps> = ({
    className,
    // color = 'action',
    fontSize = 'medium',
    title = 'Logo',
    white = false,
    // ...rest
}) => (
    <SvgIcon
        component={white ? LogoWhiteSvg : LogoSvg}
        className={classNames(
            styles.logo,
            className,
            styles[`size--${fontSize}`]
        )}
        title={title}
        inheritViewBox
    />
);

export default Logo;
